<template>
  <div class="customerMessage">
    <div class="avatar">
      <img style="width: 100%;height: 100%" class="visitor-img" :src="config.servicePicture ? config.servicePicture : require('@/assets/img/customer-img.png')"/>
    </div>
    <div class="cont">
      <div class="name">{{$t('serviceSys')}}</div>
      <div class="message-cont shadow">
        <div class="skill-page">
          <div class="skill-tip">{{$t('selectSkill')}}</div>
          <ul v-show="!isChooseGroupList" class="skill-group">
            <li class="skill-item" v-for="(item, index) in channelGroupVoList" :key="index" @click="swicthGroup(item)">
              <span class="text">{{item.groupName}}</span>
              <!-- <span style="margin-left: 20px;color: red" v-if="item.unreadMsgCount">{{item.unreadMsgCount}}</span> -->
            </li>
          </ul>
          <ul v-show="isChooseGroupList" class="skill-group">
            <li class="skill-item choose" v-for="(item, index) in channelGroupVoList" :key="index">
              <span class="text">{{item.groupName}}</span>
              <!-- <span style="margin-left: 20px;color: red" v-if="item.unreadMsgCount">{{item.unreadMsgCount}}</span> -->
            </li>
          </ul>
          <div style="margin-top: 10px">{{$t('clickToSelectSkill')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions} from 'vuex'
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'

export default {
  inject: ['selectedSkill', 'transferLabor'],
  data () {
    return {
      isChooseGroupList: false
    }
  },
  computed: {
    ...mapState({
      config: 'config',
      visitorInfo: 'visitorInfo',
      channelGroupVoList: 'channelGroupVoList'
    })
  },
  methods: {
    ...mapMutations({
      setVisitorInfo: 'setVisitorInfo'
    }),
    ...mapActions({
      get_queue: 'get_queue'
    }),
    swicthGroup (item) {
      this.isChooseGroupList = true
      console.log('查看选择的技能组', item)
      let params = {
        tenantId: this.visitorInfo.tenantId,
        groupId: item.groupId,
        visitorId: this.visitorInfo.visitorId,
      }
      ajax.get(apis.chat.resetUnReadCount, {params}).then((res) => {
        if (res.success) {}
        this.$store.commit('set_isEndChat', true)
        this.selectedSkill(item)
      })
    }
  }
}
</script>
<style scoped lang="less">
  .customerMessage{
    margin-top: 10px;
    display: flex;
    .avatar{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #ddd;
    }
    .cont{
      padding-left: 10px;
      .message-cont{
        max-width: 400px;
        min-height: 30px;
        padding: 6px 10px;
        border-radius: 5px;
        background-color: #fff;
        margin-top: 5px;
        word-break: break-word;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
      }
    }
    .withdraw{
      margin-top: 30px;
      margin-left: 10px;
    }
  }
  .skill-page{
    .skill-item{
      cursor: pointer;
      padding: 5px;
      border-radius: 4px;
      border: solid #2d85f3 1px;
      margin-top: 5px;
      .text{
        color: #2d85f3;
      }
    }
  }
  .choose {
    color: rgb(187, 187, 187);
    border-color: rgb(187, 187, 187) !important;
    .text {
      color: rgb(187, 187, 187) !important;
    }
  }
</style>
